<template>
  <div class="main flex">
    <div class="main__right overflow_content">
      <div class="main__conten">
        <router-view />
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.main {
  width: 100%;
  position: relative;
  &__mobile_open{
    flex: 3;
  }
  &__mobile{
    flex: 0;
  }
  &__left {
    flex: 1.4;
  }
  &__right {
    background: #f3f3f3;
    flex: 8.5;
  }
  .main__conten {
    padding: 30px;
  }
}
</style>
<script>
export default {
  name: "today",
  data() {
    return {
    };
  },
  components: {
  },
  computed: {
  },
  methods: {
  },
};
</script>